import React from 'react';
import PropTypes from 'prop-types';

const CardFooter = ({ primary, link, label, handleClick }) => (
  <div className="card-footer">
    <a
      className={`tsla-btn ${primary ? 'tsla-btn--blue' : 'tsla-btn--grey'}`}
      href={link}
      onClick={handleClick}
      rel="noopener noreferrer"
      target="_blank"
    >
      {label}
    </a>
  </div>
);

CardFooter.propTypes = {
  primary: PropTypes.bool.isRequired,
  link: PropTypes.string,
  label: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
};

CardFooter.defaultProps = {
  link: '',
  label: '',
};

export default CardFooter;
